
export default {
  props: {
    title: { type: String, default: "" },
    handle: { type: String, required: true },
    selectedVariantId: { type: [Number, String], required: true },
  },
};
